import { Helmet } from 'react-helmet-async'

export function PostIndexHelmet() {
  const title = 'כתבות אנימה, מדריכים וביקורות | AniZone - אניזון'
  const description =
    'גלו את כל הכתבות באתר AniZone – ביקורות על סדרות אנימה, מדריכי צפייה, כתבות מיוחדות, חדשות מעולם האנימה והמנגה, המלצות, טרנדים, פאנלים, והשקות עונתיות. כל מה שמעניין otaku בישראל!'
  const url = 'https://www.anizone.co.il/posts'
  const image =
    'https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/uploads/2025/05/logo-1747045147075.webp'

  const keywords = `
אנימה, מנגה, כתבות אנימה, חדשות אנימה, פוסטים על אנימה, ביקורות אנימה, מדריכי אנימה, כתבות מקוריות, סדרות אנימה, מדריך צפייה, otaku ישראל, בלוג אנימה, בלוג מנגה, סדרות יפניות, קהילת אנימה, קהילת מנגה, פאנלים, המלצות אנימה, אנימה פופולרית, אנימה מומלצת, סקירות אנימה, כתבות חדשות, טריילרים, דמויות אהובות, השקות עונה, עונות אנימה, כתבות עומק, ניתוח דמויות, כתבות בעברית על אנימה, AniZone, אניזון, כתבות באתר AniZone, כתבות מעריצים, כתבות פאנ-סאב, מדריכי עולם האנימה, כתבות על סטודיו ג׳יבלי, crunchyroll, funimation, כתבות מנגה, manga blog, anime blog, reviews, anime recommendations, hebrew anime articles
`.trim()

  return (
    <Helmet>
      {/* 🧠 כותרת ותיאור */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* 🖼️ Open Graph (Facebook, WhatsApp וכו') */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="לוגו AniZone - כתבות אנימה" />
      <meta property="og:site_name" content="AniZone" />

      {/* 🐦 Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={url} />

      {/* 🧩 JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: title,
            url: url,
            image: {
              '@type': 'ImageObject',
              url: image,
            },
            description: description,
            inLanguage: 'he',
            isPartOf: {
              '@type': 'WebSite',
              name: 'AniZone',
              url: 'https://www.anizone.co.il',
            },
            mainEntity: {
              '@type': 'ItemList',
              name: 'כתבות באתר AniZone',
              numberOfItems: 50,
              itemListOrder: 'http://schema.org/ItemListOrderDescending',
              itemListElement: [],
            },
            keywords,
          }),
        }}
      />
    </Helmet>
  )
}
